"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTeamsManifestArguments = exports.SelectTeamsManifestOptions = void 0;
exports.SelectTeamsManifestOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the Microsoft Teams app manifest template file path, it can be either absolute path or relative path to project root folder, defaults to './appPackage/manifest.json'",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.SelectTeamsManifestArguments = [];
//# sourceMappingURL=SelectTeamsManifestOptions.js.map